import type React from "react";

import { HorizontalBarChart02Icon } from "@/components/Icons/HorizontalBarChart02Icon";
import { EditPollModal, type PollData } from "@/components/Poll/EditPollModal";
import { Button } from "@/design-system/Button";
import { useBool } from "@/hooks/useBool";
import { useTranslation } from "@/translations";

type AdminCreatePostFormAddPollButtonProps = {
  onAddPoll: (data: PollData) => void;
};

export function AdminCreatePostFormAddPollButton({
  onAddPoll,
}: AdminCreatePostFormAddPollButtonProps): React.ReactNode {
  const [isPollModalOpened, pollModalHandler] = useBool(false);

  const { t } = useTranslation();

  return (
    <>
      <Button
        variant="soft"
        icon={<HorizontalBarChart02Icon />}
        size="sm"
        onClick={pollModalHandler.setTrue}
        data-testid="add-poll-btn"
      >
        {t("page.admin-create-post.form.btn.add-poll")}
      </Button>
      <EditPollModal isOpened={isPollModalOpened} onOpenChange={pollModalHandler.set} onConfirm={onAddPoll} />
    </>
  );
}
